<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/finance-config/invoice-name-management">财务中心设置列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="$route.meta.type === 'create' ? invoiceNameAddRule : invoiceNameEditRule"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <!-- 修改数据  -->
            <template v-if="$route.meta.type === 'edit'">
              <el-form-item label="开票名称"
                            prop="name">
                <label>{{ form.name }}</label>
              </el-form-item>
              <el-form-item label="开票名称类别"
                            prop="type_name">
                <label>{{ form.type_name }}</label>
              </el-form-item>
            </template>
            <!-- 添加数据  -->
            <template v-if="$route.meta.type === 'create'">
              <el-form-item label="开票名称"
                            prop="name">
                <el-input v-model="form.name" placeholder="请输入开票名称"></el-input>
              </el-form-item>
              <el-form-item label="开票名称类别"
                            prop="type_id">
                <remote-select
                  class="width-max"
                  clearable
                  id-key="id"
                  label-key="name"
                  value-key="id"
                  keyword-key="name"
                  placeholder="请输入开票名称类别名称进行搜索"
                  v-model="form.type_id"
                  :query-request="(_)=>invoiceNameTypeLists(Object.assign(_, {is_disabled: 0, need_full_match: 1}))"
                  :find-request="getInvoiceNameType">
                </remote-select>
              </el-form-item>
            </template>

            <el-form-item label="税率"
                          prop="tax_rate">
              <el-input v-model="form.tax_rate" placeholder="请填写税率">
                 <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="商品编码"
                          prop="product_num">
              <el-input v-model="form.product_num" placeholder="请填写商品编码"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary"
                     native-type="submit">保存
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { invoiceNameAddRule, invoiceNameEditRule } from '../../finance-config.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      invoiceNameAddRule,
      invoiceNameEditRule,
      form: {
        name: '',
        type_id: null,
        type_name: '',
        tax_rate: null,
        product_num: null,
        full_name: null,
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map(['invoiceNameTypeLists', 'getInvoiceNameType']),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.common('getInvoiceName', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createInvoiceName', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/finance-config/invoice-name-management'})
        })
      })
    },
    update (id) {
      request.common('editInvoiceName', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/finance-config/invoice-name-management'})
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/invoice-name/FinanceInvoiceNameForm.vue